import { get, post } from '../services/common/common.service';
import { adminScreenRole } from '../constants/endpoint';

export const fetchRoles = () => {
  return get(adminScreenRole.getRoles);
};

export const fetchPermissionRole = (payload) => {
  return get(`${adminScreenRole.getRolePermission}?roleId=${payload}`);
};

export const setRolePermission = (payload) => {
  return post(adminScreenRole.setRolePermission, payload);
};

export const loginWithToken = (payload) => {
  return post(adminScreenRole.loginWithToken, payload);
};
